/**
 * Account preferences: generic key-value map persisted per-account.
 *
 * Keys use dotted notation grouped by feature area (e.g. "eggs.useTwitterBird").
 * New keys can be added here without schema or API migration — the Zod schema
 * uses `catchall(z.unknown())` so older servers preserve keys they don't know.
 */
import { z } from "zod";
export const AccountPreferencesMapSchema = z
    .object({
    "eggs.useTwitterBird": z.boolean().optional(),
})
    .catchall(z.unknown());
export const DEFAULT_ACCOUNT_PREFERENCES = {};
